export const targetShowPolygonZoom = 15.5;
export const polygonColor = [
  { color: '#26B5ED', fillOpacity: 0.04 },
  // 奥乐齐商品房
  { color: '#FF7800', fillOpacity: 0.08 },
  // 奥乐齐新村房
  { color: '#4BAA1E', fillOpacity: 0.08 },
  // 奥乐齐商住两用房
  { color: '#AF8AFF', fillOpacity: 0.08 },
];
// 61-奥乐齐商品房; 62-奥乐齐新村房 67-商住两用房
export const targetALQType1 = 61;
export const targetALQType2 = 62;
export const targetALQType3 = 67;

